import React, { useState, useEffect } from 'react';
import './Toast.css';

// Estado global para las notificaciones
let toastListeners = [];
let currentUserRole = null;

export const setToastUserRole = (role) => {
  currentUserRole = role;
};

export const showToast = (message, type = 'info', adminOnly = false) => {
  // Si es solo para admin y el usuario no es admin, no mostrar
  if (adminOnly && currentUserRole !== 'admin' && currentUserRole !== 'superadmin') {
    return;
  }
  
  toastListeners.forEach(listener => listener(message, type));
};

function Toast() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const addToast = (message, type) => {
      const id = Date.now() + Math.random();
      const newToast = { id, message, type };
      
      setToasts((prev) => [...prev, newToast]);

      setTimeout(() => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
      }, 4000);
    };

    // Agregar listener
    toastListeners.push(addToast);

    // Cleanup
    return () => {
      toastListeners = toastListeners.filter(listener => listener !== addToast);
    };
  }, []);

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast-${toast.type}`}>
          <span className="toast-icon">
            {toast.type === 'success' && '✅'}
            {toast.type === 'error' && '❌'}
            {toast.type === 'info' && 'ℹ️'}
            {toast.type === 'warning' && '⚠️'}
          </span>
          <span className="toast-message">{toast.message}</span>
        </div>
      ))}
    </div>
  );
}

export default Toast;